import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertDialogData {
  message: string;
  confirmButtonColor?: string;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.html',
  styleUrls: ['./alert-dialog.scss'],
})
export class AlertDialog implements OnInit {
  confirmButtonColor: string = 'warn';

  constructor(
    public dialogRef: MatDialogRef<AlertDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData
  ) {}

  ngOnInit() {
    if (this.data.confirmButtonColor) {
      this.confirmButtonColor = this.data.confirmButtonColor;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
